const PageMixin = {
  methods: {
    pageBack() {
      this.$router.go(-1)
    },
  },
}

export default PageMixin